export const ASSIGN_USERS_AS_ADMIN_REQUEST = "ASSIGN_USERS_AS_ADMIN_REQUEST";

export const SAVE_BASIC_INFO_DETAILS_REQUEST =
  "SAVE_BASIC_INFO_DETAILS_REQUEST";

export const SAVE_BASIC_INFO_DETAILS_SUCCESS =
  "SAVE_BASIC_INFO_DETAILS_SUCCESS";

export const GET_BASIC_INFO_DETAILS_REQUEST = "GET_BASIC_INFO_DETAILS_REQUEST";

export const GET_EMPLOYEE_FLOW_STAGING_REQUEST =
  "GET_EMPLOYEE_FLOW_STAGING_REQUEST";

export const UPDATE_EMPLOYEE_FLOW_STAGING_REQUEST =
  "UPDATE_EMPLOYEE_FLOW_STAGING_REQUEST";

  export const SET_fLAG_AS_ADMIN_EMPLOYEE_FLOW_STAGING_REQUEST =
  "SET_fLAG_AS_ADMIN_EMPLOYEE_FLOW_STAGING_REQUEST";

export const SAVE_ADMIN_INFO_DETAILS_REQUEST =
  "SAVE_ADMIN_INFO_DETAILS_REQUEST";

export const GET_ADMIN_INFO_DETAILS_REQUEST = "GET_ADMIN_INFO_DETAILS_REQUEST";
export const SAVE_DEMOGRAPHIC_INFO_DETAILS_REQUEST =
  "SAVE_DEMOGRAPHIC_INFO_DETAILS_REQUEST";
export const GET_DEMOGRAPHIC_INFO_DETAILS_REQUEST =
  "GET_DEMOGRAPHIC_INFO_DETAILS_REQUEST";

export const SAVE_OWNERSHIP_INFO_DETAILS_REQUEST =
  "SAVE_OWNERSHIP_INFO_DETAILS_REQUEST";
export const GET_OWNERSHIP_INFO_DETAILS_REQUEST =
  "GET_OWNERSHIP_INFO_DETAILS_REQUEST";

export const SAVE_DOCUMENT_INFO_DETAILS_REQUEST =
  "SAVE_DOCUMENT_INFO_DETAILS_REQUEST";

export const GET_DOCUMENT_INFO_DETAILS_REQUEST =
  "GET_DOCUMENT_INFO_DETAILS_REQUEST";

  export const SAVE_OTHER_INFO_DETAILS_REQUEST =
  "SAVE_OTHER_INFO_DETAILS_REQUEST";

export const GET_OTHER_INFO_DETAILS_REQUEST =
  "GET_OTHER_INFO_DETAILS_REQUEST";

  export const SAVE_HOSTEL_INFO_DETAILS_REQUEST =
  "SAVE_HOSTEL_INFO_DETAILS_REQUEST";

export const GET_HOSTEL_INFO_DETAILS_REQUEST =
  "GET_HOSTEL_INFO_DETAILS_REQUEST";

  export const GET_OWNERSHIPTYPEDROPDOWN_DETAILS =
  "GET_OWNERSHIPTYPEDROPDOWN_DETAILS";

    export const GET_KEYSPECIALDROPDOWN_DETAILS =
  "GET_KEYSPECIALDROPDOWN_DETAILS";

      export const GET_ACCREDITATIONDROPDOWN_DETAILS =
  "GET_ACCREDITATIONDROPDOWN_DETAILS";

  export const GET_SOCIAL_INFO_DETAILS_REQUEST =
  "GET_SOCIAL_INFO_DETAILS_REQUEST";

  export const SAVE_SOCIAL_INFO_DETAILS_REQUEST =
  "SAVE_SOCIAL_INFO_DETAILS_REQUEST";


  export const SET_HOSTEL_FACILITY =
  "SET_HOSTEL_FACILITY";

    export const SET_ADMIN_FACILITY =
  "SET_ADMIN_FACILITY";


  


// staging Employe
export const SET_EMPLOYEE_FLOW_STAGE = "SET_EMPLOYEE_FLOW_STAGE";
export const SET_EMPLOYEE_FLOW_STAGE_SUCCESS = "SET_EMPLOYEE_FLOW_STAGE_SUCCESS";
export const SET_SKIP_STAGING_API = "SET_SKIP_STAGING_API";
